import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';
import { TesterModeBanner } from '../course/TesterModeBanner';

export function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TesterModeBanner />
      <div className="flex flex-1">
        <Sidebar 
          isOpen={sidebarOpen} 
          onToggle={() => setSidebarOpen(!sidebarOpen)} 
        />
        <main className="flex-1 min-h-screen">
          <div className="p-4 md:p-8 lg:p-12 pt-20 md:pt-8">
            {children}
          </div>
        </main>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
}
